import React from 'react';

const IndexPage = () => {
	return <div className="index_page" />;
};

export default IndexPage;
